function replaceUrlParam(url, paramName, paramValue)
{
    if (paramValue == null) {
        paramValue = '';
    }
    var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
    if (url.search(pattern)>=0) {
        return url.replace(pattern,'$1' + paramValue + '$2');
    }
    url = url.replace(/[?#]$/,'');
    return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}
$(document).ready(function(){

// Save existing sort parameters
Shopify.queryParams = {};
if(location.search.length) {
    for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
    }
}

// Add existing sort parameters to current URL
$('#SortBy').on('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
$('#SortByD').on('change', function(e) {
    var value = e.currentTarget.value;
    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
});
  
  
  $('#exit-filter').click(function(){
  	$('#mobile-filters').removeClass('active');
    scrollLock.enablePageScroll();
  });
  $('.filter-trigger').on('click', function(){
  	$('#mobile-filters').addClass('active');
    scrollLock.disablePageScroll();
  });
  $('#desktop-filters.cc-collection-filters .filter-button').on('click', function(){
    var findOptions = 'optionsD-' + $(this).attr('data-trigger');
    if($(this).hasClass('active')){
    	$(this).removeClass('active');
      	$('#' + findOptions).removeClass('active');
    }
    else{
        $('#desktop-filters.cc-collection-filters .filter-button').removeClass('active');
        $('#desktop-filters.cc-collection-filters .nav').removeClass('active');
    	$(this).addClass('active');
      	$('#' + findOptions).addClass('active');
    }
  });
  $('#mobile-filters.cc-collection-filters .filter-button').on('click', function(){
    var findOptions = 'optionsM-' + $(this).attr('data-trigger');
    if($(this).hasClass('active')){
    	$(this).removeClass('active');
      	$('#' + findOptions).removeClass('active');
    }
    else{
        $('#mobile-filters.cc-collection-filters .filter-button').removeClass('active');
        $('#mobile-filters.cc-collection-filters .nav').removeClass('active');
    	$(this).addClass('active');
      	$('#' + findOptions).addClass('active');
    }
  });

/* $("a[href='#top']").on('click', function(e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 });
});
$(window).on('scroll', function() {
    var y_scroll_pos = window.pageYOffset;
    var scroll_pos_test = 150;

    if(y_scroll_pos > scroll_pos_test) {
      $("#cc-scroll-top").show();
    }
  	else{
  		$("#cc-scroll-top").hide();
    }
}); */

var moreColorsSwiper = new Swiper(".more-colors-slider", {
  slidesPerView: 2,
  slidesPerGroup: 2,
  navigation: {
    enabled: false
  },
  breakpoints: {
    900: {
      spaceBetween: 5,
      slidesPerView: 3,
      slidesPerGroup: 3,
      loopAddBlankSlides: false,
      loop: true,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    },
  }
})
$("body").on('click', '.readers-powers button', function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
    var newPower = $(this).attr('variant-name').replace('+', '');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	var mainContainer = $(this).closest('.cc-collection-item');
    var urlSelector = $('.featured-container', mainContainer);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'power', newPower);
    urlSelector.attr("href", newHref);
  	$('.main-info h4 a', mainContainer).attr("href", newHref);
  	$('.review-wrap', mainContainer).attr("href", newHref);
  
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".snow-helmet-sizes button", function(){
	var vId = $(this).attr('variant-id');
  	var vStatus = $(this).attr('variant-status');
  	var atcForm = $(this).closest('.cc-collection-item').find('.shopify-product-form:first');
  	var container = $(this).parent();
  	$('button', container).removeClass('selected');
  	$(this).addClass('selected');
  	$('input[name=id]', atcForm).val(vId);
  	$('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  	if(vStatus == "true"){
    	$('.BIS_trigger', atcForm).hide();
      	$('[data-atc]', atcForm).show();
    }
  	else{
    	$('.BIS_trigger', atcForm).show();
      	$('[data-atc]', atcForm).hide();
    }
});
$("body").on('click', ".rx-lens-colors .rx-swatch", function(){  
    var newImg = $(this).attr('rx-image');
    var newColor = $(this).attr('rx-color');
  	var container = $(this).closest('.cc-collection-item');
    var imgSelector = $('.featured-container img', container);
    var urlSelector = $('.featured-container', container);
    var myHref = urlSelector.attr("href");
    var newHref = replaceUrlParam(myHref, 'color', newColor);
  	$('.rx-lens-colors .rx-swatch', container).removeClass('selected');
  	$(this).addClass('selected');
    urlSelector.attr("href", newHref);
    imgSelector.attr("src", newImg);
    imgSelector.attr("data-hover-src", newImg);
  	$('.main-info h4 a', container).attr("href", newHref);
  	$('.review-wrap', container).attr("href", newHref);
    $('.shopify-product-form a', container).attr("href", newHref); 
 }); 

 function formatPrice(price, currency) {
   return new Intl.NumberFormat('en-US', {
     style: 'currency',
     currency: currency
   }).format(price);
 }

 var shopCurrency = Shopify.currency.active;

 function getLocalizedPrice(price, callback) {
    var convertedPrice = price;
    callback(convertedPrice);
 }

 $('body').on('click','.sun-variants .sw-extra', function(){
	var newImg = $(this).attr('data-image');
  var newPrice = $(this).attr('data-price');
  var newHoverImg = $(this).attr('data-hover-image');
  var mainContainer = $(this).closest('.cc-collection-item');
  var imgSelector = $('.featured-container img', mainContainer);
  var priceSelector = $('.main-info .flow-price', mainContainer);
  var myHref = $(this).attr('data-href');
  var vId = $(this).attr('variant-id');
  var vJson = $(this).attr('data-product-json');
  var vStatus = $(this).attr('variant-status');
  var container = $(this).parent();
  var atcForm = $('.shopify-product-form', mainContainer);
  $('.sw-extra .bl-color-sun', container).removeClass('active');
  $('.bl-color-sun',this).addClass('active');
  imgSelector.attr("src", newHoverImg).attr('data-hover-src', newImg);
  $('.main-info h4 a', mainContainer).attr("href", myHref);
  $('.review-wrap', mainContainer).attr("href", myHref);
  $('.featured-container',mainContainer).attr("href", myHref);;
  $('input[name=id]', atcForm).val(vId);
  $('.BIS_trigger', atcForm).attr('data-variant-id',vId);
  $('.BIS_trigger', atcForm).attr('data-product-data',vJson);
  if(vStatus == "true"){
    $('.BIS_trigger', atcForm).hide();
      $('[data-atc]', atcForm).show();
  }
  else{
    $('.BIS_trigger', atcForm).show();
      $('[data-atc]', atcForm).hide();
  }
  // if (typeof Flow.getExperience === "function" && Flow.getExperience()) {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice);
  //   Flow.variants.localize(({ force: true }));
  // } else {
  //   priceSelector.attr("flow-variant", vId).attr('flow-default', newPrice).text(newPrice);
  // }
  getLocalizedPrice(newPrice, function(localizedPrice) {
    priceSelector
      .attr("globale-variant", vId)
      .attr("globale-default", newPrice)
      .text(formatPrice(localizedPrice, shopCurrency));
  });
});

  $('#learn-more.read').on('click', function(){
  	$('#learn-more-content').slideToggle();
    $(this).toggleClass('active');
    if($('span',this).text() == "Read More"){
    	$('span',this).text("Read Less");
    }else{
		$('span',this).text("Read More");
    }
  });
});

// Function to reinitialize the swiper
function recreateSwiperOnCollectionPage() {
  const swiperProductImageEl = document.querySelector('.product-image-swiper');
  if (!swiperProductImageEl) return;

  if (typeof productImageSwiper !== "undefined" && productImageSwiper instanceof Swiper) {
    productImageSwiper.destroy(true, true);
  }
  productImageSwiper = new Swiper(".product-image-swiper", {
    slidesPerView: 1,
    pagination: {
      el: ".product-image-swiper-pagination",
      clickable: true,
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const tabHandle = params.get('tab');

  let tabToActivate;

  if (tabHandle) {
    tabToActivate = document.querySelector(
      `.collection-tab-item[onclick*="'${tabHandle}'"]`
    );
  }

  if (!tabToActivate) {
    tabToActivate = document.querySelector('.collection-tab-item'); // fallback to first tab
  }

  if (tabToActivate) {
    setActiveTab(tabToActivate);
  }
  switchCollection(tabHandle || tabToActivate?.getAttribute('onclick').match(/'([^']+)'/)[1], tabToActivate);
});

function setActiveTab(tabElement) {
  document.querySelectorAll('.collection-tab-item').forEach(tab => {
    tab.classList.remove('text-black', 'border-b-2', 'border-black', 'font-bold');
    tab.classList.add('text-gray-600');
  });

  tabElement.classList.remove('text-gray-600');
  tabElement.classList.add('text-black', 'border-b-2', 'border-black', 'font-bold');
}


async function switchCollection(handle, clickTabItem) {

  setActiveTab(clickTabItem);

  const endOfMessage = `<h2 class="end-of-message text-center flex justify-center items-center mt-16 text-[20px] leading-6 text-black font-bold">That's the full lineup (for now)</h2>`

  clickTabItem.classList.remove('text-gray-600', 'border-b-0', 'border-transparent');
  clickTabItem.classList.add('text-black', 'border-b-2', 'border-black');

  const grid = document.querySelector('.product-grid');
  if (!grid) return;

  const getSectionConfig = () => ({
    productLimit: parseInt(grid.dataset.productLimit, 10) || 8,
    loader: grid.dataset.loader || ''
  });

  const { loader, productLimit } = getSectionConfig();

  grid.innerHTML = '';

  const containerGrid = document.createElement('div');
  containerGrid.className = 'main-collection-product-grid grid grid-cols-2 md:grid-cols-4 gap-4';

  const loader_image = document.createElement('img');
  loader_image.src = loader;
  loader_image.alt = "Loading...";
  loader_image.className = 'w-32 h-32';

  const loaderWrapper = document.createElement('div');
  loaderWrapper.className = 'w-full flex justify-center my-5';
  loaderWrapper.style.display = 'none';
  loaderWrapper.appendChild(loader_image);

  grid.appendChild(containerGrid);
  grid.appendChild(loaderWrapper);

  let currentPage = 1;
  let loading_state = false;
  let allProductsLoaded = false;

  async function fetchCollectionProducts(page) {
    const res = await fetch(`/collections/${handle}/products.json?limit=${productLimit}&page=${page}`);
    if (!res.ok) throw new Error('Failed to fetch collection');
    const data = await res.json();
    return data.products;
  }

  function renderProductHTML(product) {
    return `
      <div class="relative group">
        <div class="swiper product-image-swiper aspect-[340/280] rounded-lg md:rounded-xl">
          <div class="swiper-wrapper">
            ${renderProductImage(product)}
          </div>
          <div class="swiper-pagination product-image-swiper-pagination !bottom-3 md:!bottom-4 [&_.swiper-pagination-bullet-active]:!bg-[#051D5E]"></div>
        </div>
      </div>
      <div class="leading-none mt-3 text-sm md:text-base font-medium text-black bold">${product.title}</div>
      <div class="product-price-discount flex gap-2 items-center">
        <span class="text-sm leading-[17px] text-black font-bold">${formatMoney(product.variants[0].price)}</span>
        ${returnCompareAtPrice(product)}
      </div>
    `;
  }

  function renderProductImage(product) {
    const swiperSlides = product.images.slice(0, 4).map(image => `
      <div class="swiper-slide bg-[#f2f4f7] !flex justify-center">
        <img 
          src="${image.src}&width=500" 
          alt="product_image" 
          width="500" 
          loading="lazy" 
          class="object-contain mix-blend-darken w-[70%]"
        />
      </div>
    `).join('');

    return `${swiperSlides}`;
  }

  function formatMoney(price) {
    const shopCurrency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: shopCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(price);
  }

  function returnCompareAtPrice(product) {
    if (!product.variants[0].compare_at_price || product.variants[0].compare_at_price <= product.variants[0].price) return '';
    const discountPercent = Math.ceil(((product.variants[0].compare_at_price - product.variants[0].price) / product.variants[0].compare_at_price) * 100);
    return `
      <div class="flex items-center gap-1">
        <span class="text-[13px] leading-[15px] text-[#6F7176B2] line-through">
          ${formatMoney(product.variants[0].compare_at_price)}
        </span>
        <span class="product-discount-percent hidden md:block text-sm leading-[17px] font-bold bg-gradient-to-r from-[#F51C82] to-[#F05223] bg-clip-text text-transparent">
          -${discountPercent}%
        </span>
      </div>
    `;
  }

  async function loadNextPage() {
    if (loading_state || allProductsLoaded) return;

    loading_state = true;
    loaderWrapper.style.display = 'flex';

    try {
      const products = await fetchCollectionProducts(currentPage);

      if (!products || products.length === 0) {
        allProductsLoaded = true;
        loaderWrapper.style.display = 'none';

        if (!grid.querySelector('.end-of-message')) {
          const endMessage = document.createElement('div');
          endMessage.innerHTML = endOfMessage;
          grid.appendChild(endMessage);
        }

        // Remove scroll listener once we're done
        window.removeEventListener('scroll', scrollHandler);
        return;
      }

      currentPage++;
      products.forEach(product => {
        const productDiv = document.createElement('div');
        productDiv.className = 'product-card';
        productDiv.dataset.productId = product.id;
        productDiv.innerHTML = renderProductHTML(product);
        containerGrid.appendChild(productDiv);
      });

      if (typeof recreateSwiperOnCollectionPage === 'function') {
        recreateSwiperOnCollectionPage();
      }
    } 
    catch (err) {
      console.error("switchCollection error:", err);
    } 
    finally {
      loading_state = false;
      loaderWrapper.style.display = 'none';
    }
  }

  function scrollHandler() {
    if (allProductsLoaded || loading_state) return;
    const scrollBottom = window.innerHeight + window.scrollY;
    const threshold = containerGrid.offsetTop + containerGrid.offsetHeight - 200;
    if (scrollBottom >= threshold) {
      loadNextPage();
    }
  }

  await loadNextPage();

  window.addEventListener('scroll', scrollHandler);
}